import { render, staticRenderFns } from "./AppContentBlockStoryImageCarousel.vue?vue&type=template&id=584e8844&scoped=true&"
import script from "./AppContentBlockStoryImageCarousel.vue?vue&type=script&lang=js&"
export * from "./AppContentBlockStoryImageCarousel.vue?vue&type=script&lang=js&"
import style0 from "./AppContentBlockStoryImageCarousel.vue?vue&type=style&index=0&id=584e8844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584e8844",
  null
  
)

export default component.exports